import React from 'react';

import {
  FieldCheckbox,
  FieldText,
  FormSchemaOptions,
  FormSchemaReturn,
} from '@explorer/forms';
import * as yup from 'yup';

/**
 * Form Validation Schema
 */
export const validationSchema = (intl) =>
  yup
    .object({
      report_asset_reason: yup.string().required(
        intl.formatMessage({
          id: 'forms-errors.required-report-asset-reason',
        }),
      ),
      options: yup.object({
        attestation_legal: yup.boolean(),
      }),
    })
    .defined();

/**
 * Form Values
 */
export type FormValues = yup.InferType<ReturnType<typeof validationSchema>>;

/**
 * Form Schema
 */
export const initializeFormSchema = ({
  formId,
  formik,
}: FormSchemaOptions): FormSchemaReturn<FormValues> => ({
  report_asset_reason: {
    formId,
    formik,
    name: 'report_asset_reason',
    renderField: (props) => (
      <FieldText
        {...props}
        label={{ id: 'forms-presets.report-asset-reason' }}
      />
    ),
  },
  options: {
    formId,
    formik,
    name: 'options',
    renderField: (props) => (
      <FieldCheckbox
        {...props}
        options={[
          {
            label: {
              id: 'forms-presets.legal-disclaimer-asset-removal-internal',
            },
            name: 'attestation_legal',
          },
        ]}
      />
    ),
  },
});
